module.exports = __webpack_public_path__ + "static/media/common_draft_request.0af39035.svg";